import { ErrorContainer, LabelComponent } from 'components';
import { useFormikContext } from 'formik';
import { JoyTextArea } from 'modules/notes/joyTextArea';

export const Note = ({ disabled }: { disabled: boolean }) => {
  const formik = useFormikContext<{
    note: string;
  }>();

  return (
    <>
      <LabelComponent mandatory text="Note" />
      <JoyTextArea
        value={formik.values.note || ''}
        id="note"
        name="note"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        placeholder="Type here"
        rows={10}
        disabled={disabled}
      />
      <ErrorContainer
        visible={formik.touched?.note && formik.errors?.note}
        errors={formik.errors}
        name="note"
      />
    </>
  );
};
